import MaterialIcon, {
  MtIcon,
} from "../../oversight-core/ui-elements/material-icon/material-icon";
import styles from "./access-state-card.module.scss";

export type AccessStateTone = "warning" | "info" | "danger";

interface IProps {
  // Any Material Symbols name; the font carries the full set.
  icon: string;
  tone: AccessStateTone;
  badge: string;
  title: string;
  description: string;
}

// Full-page explanation of why the signed-in user can't see something.
const AccessStateCard = (props: IProps) => {
  const { icon, tone, badge, title, description } = props;

  return (
    <div className={styles.wrapper}>
      <div className={`${styles.card} ${styles[tone]}`} role="alert">
        <div className={styles.iconBox}>
          <MaterialIcon icon={icon as MtIcon} size={30} />
        </div>
        <div className={`${styles.badge} font-size-10 font-weight-600 mt-3`}>
          <span className={styles.dot} />
          {badge}
        </div>
        <div className="text-dark font-size-24 font-weight-600 mt-2">
          {title}
        </div>
        <p
          className={`${styles.description} text-light font-size-13 mt-2 mb-0`}
        >
          {description}
        </p>
      </div>
    </div>
  );
};

export default AccessStateCard;
